import React from 'react'
import { strings } from '../../../lib/localization'
import { BreadcrumbItem, Breadcrumbs } from './breadcrumbs'

export const CategoryBreadcrumbs = ({ userId, answersId, categoryId, categoryName }) => {
  const breadcrumbs: BreadcrumbItem[] = [
    {
      type: 'start',
      label: strings.answersBreadcrumbHome,
      navigationParams: {}
    },
    {
      type: 'answersCategory',
      label: categoryName,
      navigationParams: {
        userId,
        answersId,
        categoryId,
        categoryName
      }
    }
  ]

  return <Breadcrumbs breadcrumbs={breadcrumbs} />
}
